import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/editModalSlice";
import { openModalDelete } from "../../store/slices/deleteModalPackageSlice";
import { getAllAds } from "../../store/slices/apiAdsSlice";
import EditModalAds from "./EditModalAds";
import { FaPencilAlt } from "react-icons/fa";
import DeleteModalAds from "./DeleteModalAds";

const TableAdsResponsive = () => {
  const dispatch = useDispatch();
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const adsData = useSelector((state) => state.apiAds.data);
  const adsArray = Array.isArray(adsData.data) ? adsData.data : [];

  const isEditModalOpen = useSelector((state) => state.editModal.isOpen);

  useEffect(() => {
    dispatch(getAllAds());
  }, [dispatch]);

  const handleEditItem = (id) => {
    setEditId(id);
    dispatch(openModal());
  };

  const handleDeleteItem = (id) => {
    setDeleteId(id);
    dispatch(openModalDelete(id));
  };

  const handleCloseEditModal = () => {
    setEditId(null);
    dispatch(closeModal());
  };

  function getStatusTextFromBoolean(value) {
    return value ? "Aktiv" : "Pasiv";
  }

  return (
    <>
      <div className="block sm:hidden space-y-4">
        {adsArray?.map((item) => (
          <div
            key={item.id}
            className="bg-white dark:bg-gray-800 shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Titulli:</strong> {item.title}
            </p>
            <p>
              <strong>Përshkrimi:</strong> {item.description}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.categoryName}
            </p>
            <p>
              <strong>Statusi:</strong>{" "}
              <span
                className={`text-white px-2 py-1 rounded-full text-xs ${
                  item.status === 1 ? "bg-green-500" : "bg-red-500"
                }`}
              >
                {getStatusTextFromBoolean(item.status)}
              </span>
            </p>
            <div>
              <strong>Foto:</strong>
              <img
                src={`https://back2.autoshkollaime.com/${item.image}`}
                alt={item.title}
                className="w-16 h-16 object-cover rounded shadow border mt-2"
              />
            </div>
            <div className="flex flex-wrap gap-2 pt-2">
              <button
                onClick={() => handleEditItem(item.id)}
                className="text-blue-500"
              >
                <FaPencilAlt
                  style={{ width: 20, height: 20, color: "#21C621" }}
                />
              </button>
              <button
                onClick={() => handleDeleteItem(item.id)}
                className="text-danger"
              >
                <DeleteModalAds id={item.id} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <EditModalAds
        id={editId}
        isOpen={isEditModalOpen}
        onClose={handleCloseEditModal}
      />
    </>
  );
};

export default TableAdsResponsive;
